import { createApp } from 'vue'
import { VueResponsiveness } from 'vue-responsiveness'
import App from './App.vue'
const app = createApp(App)
app.use(VueResponsiveness, {
  mobile: 0,
  tablet: 770,
  desktop: 1200
}).mount('#app')
